import RouteContainer from 'containers/RouteContainer';
import Component from './containers/QualityOfLifeContainer';

export const path = `${DOCUMENTS_PATH}/qol`;
export const navigation = { name: 'qol', id: 'qualityoflife.generic.title' };
export const nav15D = { name: 'qualityoflife', id: 'qualityoflife.title', nonNavigable: true };
export const navEQ5D = { name: 'eq5d', id: 'eq5d.title', nonNavigable: true };

export default RouteContainer(path, Component);
